import { createActions } from 'redux-actions';
import { request, create, update } from '../../services';
import { getInstallerFilters, getInstallerPage } from '../../reducers';
import Schemas from 'schemas';
import { normalize } from 'normalizr';
import { navigate } from 'actionCreators';
import qs from 'qs';

const {
  installerListRequest,
  installerListSuccess,
  installerListFailure,
} = createActions(
'INSTALLER_LIST_REQUEST', 'INSTALLER_LIST_SUCCESS', 'INSTALLER_LIST_FAILURE');

export function requestInstallerList() {
  return (dispatch, getState) => {
    const state = getState();
    const page = getInstallerPage(state);
    const filterParams = qs.stringify(getInstallerFilters(state));

    dispatch(installerListRequest());
    request(`installers?page=${page}&${filterParams}`)
      .then(({ json }) =>
        dispatch(installerListSuccess(json, filterParams))
      , error =>
        dispatch(installerListFailure(error)),
      );
  };
}


const {
  installerResourceRequest,
  installerResourceSuccess,
  installerResourceFailure,
} = createActions({
  INSTALLER_RESOURCE_REQUEST: id => ({ id }),
  INSTALLER_RESOURCE_SUCCESS: json => normalize(json, Schemas.INSTALLER),
}, 'INSTALLER_RESOURCE_FAILURE');

export function requestInstaller(id) {
  return (dispatch) => {
    dispatch(installerResourceRequest(id));
    request(`installers/${id}`)
      .then(({ json }) => dispatch(installerResourceSuccess(json)))
      .catch(error => dispatch(installerResourceFailure(error)));
  };
}


const {
  installerResourceCreateRequest,
  installerResourceCreateSuccess,
  installerResourceCreateFailure,
} = createActions({
  INSTALLER_RESOURCE_CREATE_SUCCESS: json => normalize(json, Schemas.INSTALLER),
}, 'INSTALLER_RESOURCE_CREATE_REQUEST', 'INSTALLER_RESOURCE_CREATE_FAILURE');

export function createInstaller(installer) {
  return (dispatch) => {
    dispatch(installerResourceCreateRequest());
    return create('installer', installer)
    .then(({ json }) =>
      Promise.all([
        dispatch(installerResourceCreateSuccess(json)),
        json,
      ]),
    )
    .catch((error) => {
      dispatch(installerResourceCreateFailure(error));
      throw error;
    });
  };
}


const {
  installerResourceUpdateRequest,
  installerResourceUpdateSuccess,
  installerResourceUpdateFailure,
} = createActions({
  INSTALLER_RESOURCE_UPDATE_SUCCESS: json => normalize(json, Schemas.INSTALLER),
}, 'INSTALLER_RESOURCE_UPDATE_REQUEST', 'INSTALLER_RESOURCE_UPDATE_FAILURE');

export function updateInstaller(installer) {
  return (dispatch) => {
    dispatch(installerResourceUpdateRequest());
    return update('installer', installer)
      .then(({ json }) =>
        Promise.all([
          dispatch(installerResourceUpdateSuccess(json)),
          dispatch(navigate(`/installers/${json.id}`)),
        ]),
      )
      .catch((error) => {
        dispatch(installerResourceUpdateFailure(error));
        throw error;
      });
  };
}

const {
  addEventToInstallerRequest,
  addEventToInstallerSuccess,
  addEventToInstallerFailure,
} = createActions({
  ADD_EVENT_TO_INSTALLER_SUCCESS: (json, installerId) => ({ event: json.event, installerId }),
}, 'ADD_EVENT_TO_INSTALLER_FAILURE', 'ADD_EVENT_TO_INSTALLER_REQUEST');

export const addEventToInstaller = (installerId, event) => (dispatch) => {
  dispatch(addEventToInstallerRequest(event));
  return request(`installers/${installerId}/events`, { method: 'POST', body: event })
    .then(({ json }) => dispatch(addEventToInstallerSuccess(json, installerId)))
    .catch(errors => dispatch(addEventToInstallerFailure(errors)));
};


export function setInstallerFilters(filter) {
  return (dispatch) => {
    dispatch({ type: 'INSTALLER_SET_FILTER', payload: filter });
    dispatch({ type: 'INSTALLER_RESET_PAGINATION' });
    dispatch(requestInstallerList());
  };
}

export function resetInstallerFilters() {
  return (dispatch) => {
    dispatch({ type: 'INSTALLER_RESET_FILTERS' });
    dispatch({ type: 'INSTALLER_RESET_PAGINATION' });
    dispatch(requestInstallerList());
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/installers.js